var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 3.75C13.4678 3.75118 11.9662 4.17857 10.663 4.98437C9.35988 5.79017 8.30658 6.94262 7.62094 8.31281C6.80527 8.19385 5.97385 8.24424 5.17852 8.46082C4.38319 8.67741 3.64102 9.05555 2.9983 9.57166C2.35558 10.0878 1.8261 10.7308 1.44288 11.4606C1.05966 12.1904 0.830926 12.9913 0.770945 13.8134C0.710965 14.6355 0.821022 15.4612 1.09425 16.2388C1.36749 17.0165 1.79803 17.7296 2.35903 18.3335C2.92003 18.9375 3.59946 19.4193 4.35493 19.749C5.1104 20.0788 5.92571 20.2493 6.75 20.25H15C17.188 20.25 19.2865 19.3808 20.8336 17.8336C22.3808 16.2865 23.25 14.188 23.25 12C23.25 9.81196 22.3808 7.71354 20.8336 6.16637C19.2865 4.61919 17.188 3.75 15 3.75ZM15 18.75H6.75C5.55653 18.75 4.41193 18.2759 3.56802 17.432C2.72411 16.5881 2.25 15.4435 2.25 14.25C2.25 13.0565 2.72411 11.9119 3.56802 11.068C4.41193 10.2241 5.55653 9.75 6.75 9.75C6.85312 9.75 6.95625 9.75 7.05844 9.76031C6.85333 10.4892 6.74955 11.2428 6.75 12C6.75 12.1989 6.82902 12.3897 6.96967 12.5303C7.11032 12.671 7.30109 12.75 7.5 12.75C7.69891 12.75 7.88968 12.671 8.03033 12.5303C8.17098 12.3897 8.25 12.1989 8.25 12C8.25 10.665 8.64588 9.35993 9.38758 8.2499C10.1293 7.13987 11.1835 6.2747 12.4169 5.76381C13.6503 5.25292 15.0075 5.11925 16.3169 5.3797C17.6262 5.64015 18.829 6.28302 19.773 7.22703C20.717 8.17103 21.3599 9.37377 21.6203 10.6831C21.8808 11.9925 21.7471 13.3497 21.2362 14.5831C20.7253 15.8165 19.8601 16.8707 18.7501 17.6124C17.6401 18.3541 16.335 18.75 15 18.75Z",
    fill: "var(--fill-0, #204066)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCloud);
export default __webpack_public_path__ + "static/media/custom-cloud.693e53a0209da61e03a956b234b66b54.svg";
export { ForwardRef as ReactComponent };